import React, { forwardRef } from 'react'
import { Box, Dialog, DialogContent, Grow, IconButton } from '@mui/material'
import { motion } from 'framer-motion'
import { Close } from '@mui/icons-material'
import { RiskProfileAdjustment } from '../RiskAssessment/RiskProfileAdjustment'

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

export default function RiskProfileModal({ onClose, currentRiskLevel }) {
  return (
    <Dialog
      open
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={'md'}
      PaperProps={{
        sx: {
          overflow: { xs: 'auto', sm: 'visible' },
          margin: '16px',
          width: 'calc(100% - 32px)',
        },
      }}
    >
      <DialogContent sx={{ overflow: 'visible' }}>
        <motion.div
          key="risk-profile"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
          <Box
            sx={{
              justifyContent: 'space-between',
              position: 'relative',
              top: { xs: -8, sm: -64 },
            }}
          >
            <IconButton
              onClick={onClose}
              sx={{
                position: 'absolute',
                top: 0,
                right: { xs: -8, sm: -16 },
                color: '#fff',
                zIndex: 1,
                backgroundColor: '#000',
                '&:hover': {
                  backgroundColor: '#000',
                },
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <RiskProfileAdjustment
            closeModal={onClose}
            currentRiskLevel={currentRiskLevel}
          />
        </motion.div>
      </DialogContent>
    </Dialog>
  )
}
